import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check localStorage for existing session
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (email, password) => {
    // Dummy credentials check
    if (
      (email === 'admin@communityofhubs.com' && password === 'admin123') ||
      (email === 'user@communityofhubs.com' && password === 'user123')
    ) {
      const userData = {
        email,
        name: email === 'admin@communityofhubs.com' ? 'Admin User' : 'Regular User',
        role: email === 'admin@communityofhubs.com' ? 'admin' : 'user'
      };
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('authToken', 'dummy-token-123');
      setUser(userData);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('authToken');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};